import React, { ReactNode } from 'react';
import UploadImage from '../../../../../components/envago/UploadImage/UploadImage';
import { RemoteResult } from '../../../../common/RemoteResultCommand/index.types';
import { RemoteResultCameraUpload } from '../../../../common/RemoteResultCommand/components/RemoteResultCameraUpload';
import { RemoteResultImageUpload } from '../../../../common/RemoteResultCommand/components/RemoteResultImageUpload';
import { JobPhotoFlowResult } from '../jobPhotoFlow';
import { RemoteResultConfiguration } from '../../../../common/RemoteResultCommand';

interface JobDetailsReadingImageEntryProps {
    flow: JobPhotoFlowResult;
    config: RemoteResultConfiguration;
    images: Array<string>;
    onStandardChange: (images: string[] | undefined) => void;
    onResultReceived: (result: RemoteResult | undefined, imageBase64: string) => void;
    text?: string | ReactNode;
    primary?: boolean;
    onDelete?: (index: number) => void;
    deleteDisabled?: boolean;
}

const JobDetailsReadingImageEntry = ({ flow, config, images, onStandardChange, onResultReceived, text, primary, onDelete, deleteDisabled }: JobDetailsReadingImageEntryProps) => {
    if (flow.entryMode === 'AI_CAMERA') {
        return (
            <RemoteResultCameraUpload
                config={config}
                images={images}
                allowGallery={flow.allowGallery}
                aiEnabled={flow.useAi}
                onRemoteResultReceived={onResultReceived}
                primary={primary}
                triggerText={text}
                onDelete={onDelete}
                deleteDisabled={deleteDisabled}
            />
        );
    }

    if (flow.entryMode === 'AI_DESKTOP') {
        return <RemoteResultImageUpload config={config} images={images} onRemoteResultReceived={onResultReceived} primary={primary} text={text} onDelete={onDelete} deleteDisabled={deleteDisabled} />;
    }

    return <UploadImage images={images} onChange={onStandardChange} primary={primary} text={text} onDelete={onDelete} deleteDisabled={deleteDisabled} />;
};

export default JobDetailsReadingImageEntry;
